import React from "react";
import { AgGridReact } from "ag-grid-react";
import { useMemo, useState, useCallback, useRef } from "react";

 

export const MainGrid = (props) => {
    // Setting default grid params
    const gridRef = useRef();
    const gridStyle = useMemo(
        () => ({ height: "100%", width: "100%" }),
        []
    );
    const onFirstDataRendered = useCallback((params) => {
        gridRef.current.api.sizeColumnsToFit();
    }, []);
    const defaultColDef = useMemo(
        () => ({
            sortable: true,
            filter: true,
            resizable: true,
            animateRows: true,
        }),
        []
    );

    // Declaring the api - grid connections
    const [columnDefs, setColumnDefs] = useState([
        { field: "name", enablePivot: true, pinned: "left", lockPinned: true },
        {
          field: "role",
          enablePivot: true,
          pinned: "left",
          lockPinned: true,
          maxWidth: 100,
        },
        {
          headerName: "Assigned",
          children: [
            {
              field: "budget ",
              maxWidth: 120,
            },
            { field: "actual ", maxWidth: 120 },
          ],
          enablePivot: true,
        },
        {
          headerName: "Extension",
          children: [
            { field: "budget  ", maxWidth: 120 },
            { field: "actual  ", maxWidth: 120 },
          ],
          enablePivot: true,
        },
        {
          headerName: "Not Ready for Prep",
          children: [
            { field: "budget   ", maxWidth: 120 },
            { field: "actual   ", maxWidth: 120 },
          ],
          enablePivot: true,
        },
        {
          headerName: "N/A",
          children: [
            { field: "budget    ", maxWidth: 120 },
            { field: "actual    ", maxWidth: 120 },
          ],
          enablePivot: true,
        },
        {
          headerName: "Total",
          children: [
            { field: "budget     ", maxWidth: 120 },
            { field: "actual     ", maxWidth: 120 },
          ],
          enablePivot: true,
        },
        { field: "experience", enablePivot: true },
        { field: "title", enablePivot: true },
      ]);
    
    return (
        <div className="ag-theme-balham" style={gridStyle}>
            <AgGridReact
                ref={gridRef}
                rowData={props.rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                onGridReady={props.onGridReady}
                alwaysShowHorizontalScroll={true}
                alwaysShowVerticalScroll={true}
                sideBar={"columns"}
                onFirstDataRendered={onFirstDataRendered}
            />
        </div>
    );
};
